<template>
    <div class="c-calendar__row">
        <div class="c-calendar__col">
            <div class="c-calendar__wrap">
                <button class="c-calendar__button" @click="toggleCalendar">
                    <span>
                        Calendrier
                    </span>
                    <Image id="calendar" class="" />
                </button>
                <div class="c-calendar__mobile-bg" @click="toggleCalendar"></div>
                <div class="c-calendar">
                    <button class="c-calendar__mobile-close" @click="toggleCalendar">
                        <span class="sr-only">
                            Fermer
                        </span>
                        <Image id="close" class="" />
                    </button>
                    <div class="c-calendar__inner" data-lenis-prevent>
                        <div class="c-calendar__header">
                            <button class="c-calendar__prev" @click="prevMonth" :disabled="(parseInt(new Date().toISOString().split('-')[1]) >= currentMonth+1 || currentYear > new Date().getFullYear())">
                                <span></span>
                            </button>
                            <span class="o-title-5 c-calendar__month">
                                {{ currentMonthName }} {{ currentYear }}
                            </span>
                            <button class="c-calendar__next" @click="nextMonth">
                                <span></span>
                            </button>
                        </div>
                        <div class="c-calendar__days">
                            <span>D</span>
                            <span>L</span>
                            <span>M</span>
                            <span>M</span>
                            <span>J</span>
                            <span>V</span>
                            <span>S</span>
                        </div>
                        <div class="c-calendar__dates">
                            <span 
                            v-for="date in dates" 
                            :key="date.date + '-' + date.otherMonth" 
                            :class="['c-calendar__date', 
                                { 
                                    'is-other-month': date.otherMonth, 
                                    'is-current-date': ((date.date === new Date(this.filterDates.start+'T00:00:00').getDate() || date.date === new Date(this.filterDates.end+'T00:00:00').getDate()) && !date.otherMonth),
                                    'is-disabled': (date.date < today && parseInt(new Date().toISOString().split('-')[1]) >= currentMonth+1), 
                                    'is-today': (date.date === today && parseInt(new Date().toISOString().split('-')[1]) >= currentMonth+1) , 
                                    'is-in-range': ((tempDates.includes(date.date) && !date.otherMonth) || (allDates.includes(date.date) && !date.otherMonth))
                                }
                            ]" 
                            @mouseover="setTempDate(date.date)"
                            @click="setDates(date.date)">
                                {{ date.date }}
                            </span>
                        </div>
                        <div class="o-form c-calendar__form -text-center">
                            <div class="o-checkbox__wrap">
                                <input @change="changeMonth" class="o-checkbox" type="checkbox" name="type_spectacles" id="type_spectacles" :checked="filterDates.start == new Date(currentYear, currentMonth, 1).toISOString().split('T')[0] && filterDates.end == new Date(currentYear, currentMonth + 1, 0).toISOString().split('T')[0]">
                                <label class="o-checkbox-label" for="type_spectacles">
                                    Afficher le mois au complet
                                </label>
                            </div>
                        </div>
                        <button v-if="filterDates.start != '' || filterDates.end != ''" @click="resetCalendar" class="c-calendar__button__reset" aria-label="Réinitialiser le calendrier">
                            <span class="o-button__text">Réinitialiser le calendrier</span>
                            <span class="sr-only">Réinitialiser le calendrier</span>
                            <Image id="reload" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="c-calendar__col">
            <!-- Events list -->
             <div class="c-events__calendar">
                <div class="c-events__calendar__list">
                    <div v-if="spectacles.length > 0" class="c-events__calendar__item" v-for="spectacle in sortShows" :key="spectacle.id">
                        <a :href="spectacle.url" class="c-events__calendar__image" >
                            <div class="c-events__calendar__image__wrap" v-if="spectacle.image" v-html="spectacle.image"></div>
                            <Image v-else id="event-placeholder" class="c-event-card__icon -ico-fill" />
                            <template v-if="spectacle.tag">
                                <div v-for="(tag, slug) in spectacle.tag" :class="'-' + slug" class="c-event-card__tag">{{ tag }}</div>
                            </template>
                        </a>
                        <div class="c-events__calendar__content">
                            <div v-if="spectacle.representations.length > 0" class="c-events__calendar__date o-title-5">
                                {{ currentDate(spectacle.representations) }}
                            </div>
                            <a :href="spectacle.url" class="c-events__calendar__artist o-title-3">{{ spectacle.nom_spectacle }}</a>
                            <p v-if="spectacle.nom_spectacle != spectacle.artiste" class="c-events__calendar__title -text-lg">{{ spectacle.artiste }}</p>
                            <div class="c-events__calendar__separator"></div>
                            <a :href="spectacle.url" class="c-events__calendar__button">
                                <span>
                                    Acheter
                                </span>
                                <Image id="arrow-up-right" class="c-event-card__icon" />
                            </a>
                        </div>
                    </div>
                    <div v-else class="c-events__calendar__item">
                        <div class="c-events__calendar__no-result">
                            <h2 class="o-title-4 u-mb-sm">Aucun spectacle trouvé</h2>
                            <p>
                                Aucun spectacle ne correspond à votre recherche. Veuillez modifier vos critères de recherche.
                            </p>
                        </div>
                    </div>
                </div>
             </div>
        </div>
    </div>
</template>

<script>
import Image from './parts/Image.vue'
export default {
    props: {
        spectacles: {
            type: Array,
            default: () => []
        },
        filterDates: {
            type: Object,
            default: () => {
                return {
                    start: "",
                    end: ""
                }
            }
        }
    },
    data() {
        return {
            currentMonth: new Date().getMonth(),
            currentYear: new Date().getFullYear(),
            dates: [],
            tempDate: "",
            today: new Date().getDate()
        }
    },
    components: {
        Image,
    },
    computed: {
        currentMonthName() {
            return new Date(this.currentYear, this.currentMonth).toLocaleString('fr', { month: 'long' });
        },
        allDates() {
            //I got dates.start and dates.end from the parent component and I want to return an array of all the dates between those two dates
            const start = new Date(this.filterDates.start+"T00:00:00");
            const end = new Date(this.filterDates.end+"T23:59:59");
            const dates = [];
            let currentDate = start;
            while (currentDate <= end) {
                dates.push(currentDate.getDate());
                currentDate = new Date(currentDate.setDate(currentDate.getDate() + 1));
            }
            return dates;
        },
        tempDates() {
            if (this.filterDates.start !== "" && this.filterDates.end === "") {
                const start = new Date(this.filterDates.start+"T00:00:00");
                const end = new Date(this.currentYear + "-" + String(this.currentMonth + 1).padStart(2, '0') + "-" + this.tempDate + "T23:59:59");
                const dates = [];
                let currentDate = start;
                while (currentDate <= end) {
                    dates.push(currentDate.getDate());
                    currentDate = new Date(currentDate.setDate(currentDate.getDate() + 1));
                }
                return dates;
            }  else {
                return [];
            }
        },
        sortShows() {
            return this.spectacles.sort((a, b) => {
                if(this.filterDates.start != "" || this.filterDates.end != "") {
                    const start = new Date(this.filterDates.start+"T00:00:00");
                    const end = new Date(this.filterDates.end?this.filterDates.end:this.filterDates.start+"T23:59:59");
                    //Get all the dates between the start and end dates 
                    const dates = [];
                    let aDate = new Date(a.representations[0].date_heure.split('T')[0]);
                    let bDate = new Date(b.representations[0].date_heure.split('T')[0]);

                    let currentDate = start;
                    while (currentDate <= end) {
                        dates.push(currentDate.toISOString().split('T')[0]);
                        currentDate = new Date(currentDate.setDate(currentDate.getDate() + 1));
                    }
                    //Loop through all the representations and return the date of the first one in the filterDates
                    for (let i = 0; i < a.representations.length; i++) {
                        if (dates.includes(a.representations[i].date_heure.split('T')[0])) {
                            aDate = new Date(a.representations[i].date_heure.split('T')[0]);
                        }
                    }
                    for (let i = 0; i < b.representations.length; i++) {
                        if (dates.includes(b.representations[i].date_heure.split('T')[0])) {
                            bDate = new Date(b.representations[i].date_heure.split('T')[0]);
                        }
                    }
                    return aDate - bDate;
                } else {
                    return new Date(a.representations[0].date_heure.split('T')[0]) - new Date(b.representations[0].date_heure.split('T')[0]);
                }

            });
        }
    },
    methods: {
        setTempDate(date) {
            this.tempDate = date;
        },
        setDates(date) {
            let dates = {
                start: "",
                end: ""
            };
            const selectedDate = new Date(this.currentYear, this.currentMonth, date).toISOString().split('T')[0];
            if (this.filterDates.start === "") {
                // If start date is empty, set the start date
                dates.start = selectedDate;
                dates.end = this.filterDates.end;
            } else if (new Date(this.filterDates.start+"T00:00:00").getDate() > parseInt(date)) {
                // If the selected date is before the start date, set it as the new start date
                dates.start = selectedDate;
                dates.end = "";
            } else if (this.filterDates.end !== "") {
                // If end date is already set, reset both start and end dates
                dates.start = selectedDate;
                dates.end = "";
            } else {
                // Otherwise, set it as the end date
                dates.start = this.filterDates.start;
                dates.end = selectedDate;
            }
            // Emits start and end dates to the parent component
            this.$emit('change-dates', dates);
        },
        changeMonth(event) {
            if (event.target.checked) {
                const start = new Date(this.currentYear, this.currentMonth, 1);
                const end = new Date(this.currentYear, this.currentMonth + 1, 0);
                const formatDate = (date) => {
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    return `${year}-${month}-${day}`;
                };
                // Emits start and end dates to the parent component
                this.$emit('change-dates', { start: formatDate(start), end: formatDate(end) });
            } else {
                this.$emit('reset-dates');
            }
        },
        currentDate(reps) {
            //loop through all the representations and return the date of the first one in the filterDates
            if(this.filterDates.start != "" || this.filterDates.end != "") {
                const start = new Date(this.filterDates.start+"T00:00:00");
                const end = new Date(this.filterDates.end?this.filterDates.end:this.filterDates.start+"T23:59:59");
                //Get all the dates between the start and end dates 
                const dates = [];
                let currentDate = start;
                while (currentDate <= end) {
                    dates.push(currentDate.toISOString().split('T')[0]);
                    currentDate = new Date(currentDate.setDate(currentDate.getDate() + 1));
                }
                //Loop through all the representations and return the date of the first one in the filterDates
                for (let i = 0; i < reps.length; i++) {
                    if (dates.includes(reps[i].date_heure.split('T')[0])) {
                        return reps[i].dates_format.date_visual;
                    }
                }
            } else {
                return reps[0].dates_format.date_visual;
            }
        },
        generateDates() {
            const firstDayOfMonth = new Date(this.currentYear, this.currentMonth, 1).getDay();
            const daysInMonth = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();
            const daysInPrevMonth = new Date(this.currentYear, this.currentMonth, 0).getDate();

            const dates = [];

            // Add dates from the previous month
            for (let i = firstDayOfMonth; i > 0; i--) {
                dates.push({ date: daysInPrevMonth - i + 1, otherMonth: true });
            }

            // Add dates from the current month
            for (let i = 1; i <= daysInMonth; i++) {
                dates.push({ date: i, otherMonth: false });
            }

            // Add dates from the next month
            const remainingDays = (7 - (dates.length % 7)) % 7;
            for (let i = 1; i <= remainingDays; i++) {
                dates.push({ date: i, otherMonth: true });
            }

            this.dates = dates;
        },
        prevMonth() {
            if (this.currentMonth === 0) {
                this.currentMonth = 11;
                this.currentYear--;
            } else {
                this.currentMonth--;
            }
            this.$emit('reset-dates');
            this.generateDates();
        },
        nextMonth() {
            if (this.currentMonth === 11) {
                this.currentMonth = 0;
                this.currentYear++;
            } else {
                this.currentMonth++;
            }
            this.$emit('reset-dates');
            this.generateDates();
        },
        isCurrentDate(date) {
            const today = new Date();
            return !date.otherMonth && date.date === today.getDate() && this.currentMonth === today.getMonth() && this.currentYear === today.getFullYear();
        },
        toggleCalendar() {
            document.querySelector('html').classList.toggle('has-calendar-open');
        },
        resetCalendar() {
            //Remove dates from the parent component
            this.$emit('reset-dates');
        }
    },
    mounted() {
        this.generateDates();
        //if this.filterDates.start is not empty, set the current month and year to the start date
        if (this.filterDates.start != "") {
            this.currentMonth = new Date(this.filterDates.start+"T00:00:00").getMonth();
            this.currentYear = new Date(this.filterDates.start+"T00:00:00").getFullYear();
        }
    }
}
</script>